import { useQuery } from '@tanstack/react-query'
import { getSubtitleSize } from 'service/list'

function useGetSubtitleSize() {
  return useQuery({
    queryKey: ['get-subtitle-size'],
    queryFn: () => getSubtitleSize(),
    staleTime: 6 * 1000,
  })
}

export default useGetSubtitleSize
